/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const ModFlexwijerArticles: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path d='M12.5 8.715C12.5 11.2 10.485 13.215 8 13.215C5.515 13.215 3.5 11.2 3.5 8.715C3.5 8.24708 3.8708 7.5144 4.36735 6.53325C5.16012 4.96678 6.27344 2.76695 6.71 0H7.915L7.575 7.07C6.961 7.265 6.539 7.829 6.527 8.473C6.513 9.302 7.172 9.986 8 10C8.646 9.99 9.213 9.569 9.408 8.952C9.658 8.163 9.22 7.32 8.431 7.07L8.085 0H9.29C9.72656 2.76695 10.8399 4.96678 11.6327 6.53325C12.1292 7.5144 12.5 8.24708 12.5 8.715Z' />
			<path d='M10.6043 13.405C10.8663 13.316 11.1503 13.454 11.2403 13.715L11.7403 15.22C11.7603 15.278 11.7693 15.339 11.7693 15.4C11.7723 15.729 11.5093 15.997 11.1803 16H4.8203C4.7593 15.999 4.6973 15.988 4.6383 15.969C4.3283 15.864 4.1603 15.527 4.2653 15.215L4.7653 13.715C4.76993 13.7019 4.77517 13.6893 4.78053 13.6765C4.78211 13.6727 4.78371 13.6689 4.7853 13.665C4.9023 13.415 5.2003 13.308 5.4503 13.425C7.0653 14.194 8.9403 14.194 10.5553 13.425C10.5691 13.4181 10.5837 13.4127 10.5978 13.4074C10.6 13.4066 10.6021 13.4058 10.6043 13.405Z' />
		</Svg>
	);
};

export { ModFlexwijerArticles };
